import store from '@/vuex'

function checkMenuListPermission (key, menuList) {
  if (key && menuList && menuList.length) {
    for (const menu of menuList) {
      if (menu.menuName === key) {
        return true
      }
      if (checkMenuListPermission(key, menu.sub_menu)) {
        return true
      }
    }
  }
  return false
}

export function checkMenuPermission (key) {
  const menuList = store.getters && store.getters.menuList
  if (!menuList) {
    return false
  }
  return checkMenuListPermission(key, menuList)
}

export function checkOperationPermission (key) {
  const operationList = store.getters && store.getters.operationList
  if (!operationList) {
    return false
  }
  return operationList.some(operation => {
    return `${operation.dataType}/${operation.buttonClass}` === key
  })
}



// WEBPACK FOOTER //
// ./src/utils/permission.js